"use client";

import React from "react";
import { Loader } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
function ContactFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-8 bg-muted/50 border border-border rounded-lg text-center">
        <h3 className="text-xl font-default font-semibold text-foreground mb-4">
          ¡Gracias por su mensaje!
        </h3>
        <p className="text-muted-foreground mb-6">{successMessage}</p>
        <Button onClick={resetForm} variant="outline">
          Enviar otro mensaje
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="nombre" rules={{
        required: "El nombre es obligatorio",
        minLength: {
          value: 2,
          message: "Mínimo 2 caracteres"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-serif font-semibold text-sm">Nombre</FormLabel>
              <FormControl>
                <Input placeholder="Su nombre completo" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="empresa" rules={{
        required: "La empresa es obligatoria"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-serif font-semibold text-sm">Empresa</FormLabel>
              <FormControl>
                <Input placeholder="Nombre de su empresa" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="email" rules={{
        required: "El email es obligatorio",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Email inválido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-serif font-semibold text-sm">Email</FormLabel>
              <FormControl>
                <Input type="email" placeholder="correo@empresa.com" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="telefono" rules={{
        required: "El teléfono es obligatorio",
        pattern: {
          value: /^[0-9+\-\s()]*$/,
          message: "Formato de teléfono inválido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-serif font-semibold text-sm">Teléfono</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+1 (555) 000-0000" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="mensaje" rules={{
      required: "El mensaje es obligatorio",
      minLength: {
        value: 10,
        message: "Mínimo 10 caracteres"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="font-serif font-semibold text-sm">Mensaje</FormLabel>
            <FormControl>
              <Textarea placeholder="¿Cómo podemos ayudarle a proteger su infraestructura?" className="min-h-[120px] resize-y" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-md">
          <p className="text-destructive text-sm font-medium">{submitError}</p>
        </div>}

      <div className="pt-2">
        <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto px-8 py-6 text-base font-bold bg-chart-4 text-foreground hover:bg-chart-4/90 shadow-md transition-colors">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-5" />
              Enviando...
            </> : "Enviar"}
        </Button>
      </div>
    </Form>;
}
export default function SolicitarInformacion() {
  return <section id="solicitar-información" className="py-14 md:py-16 bg-background text-foreground">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-default font-bold tracking-tight text-foreground">
            Proteja su Infraestructura de Comunicaciones
          </h2>
          <p className="mt-4 text-lg text-muted-foreground max-w-2xl mx-auto">
            Complete el formulario a continuación y un especialista se pondrá en contacto con usted a la brevedad.
          </p>
        </div>

        <div className="bg-card border border-border rounded-xl shadow-sm p-6 md:p-10">
          <FormProvider formId="demo_form_omnichannel" sectionName="Solicitar Información" defaultValues={{
          nombre: "",
          empresa: "",
          email: "",
          telefono: "",
          mensaje: ""
        }} submitText="Enviar" successMessage="Su solicitud ha sido enviada correctamente. Nos pondremos en contacto pronto.">
            <ContactFormInner />
          </FormProvider>
        </div>
      </div>
    </section>;
}